import { container } from 'tsyringe';
import { types } from './mutations';
import { FormTemplateRepository as V2FormTemplateRepository } from 'packages/form/entities/FormTemplateRepository';
var v2Repository = container.resolve(V2FormTemplateRepository);
export var actions = {
    getFormTemplatesForCompany: function (_a) {
        var commit = _a.commit, rootGetters = _a.rootGetters;
        commit(types.FORM_TEMPLATES_RETRIEVING);
        return v2Repository.listForCompany(rootGetters.currentCompanyId).then(function (templates) {
            commit(types.FORM_TEMPLATES_RETRIEVED, { formTemplates: templates });
        });
    },
    deleteFormTemplate: function (_a, formTemplate) {
        var commit = _a.commit;
        return v2Repository.delete(formTemplate.id).then(function () { return commit(types.FORM_TEMPLATE_DELETED, { formTemplate: formTemplate }); });
    },
    createFormTemplate: function (_a, formTemplate) {
        var commit = _a.commit;
        return v2Repository.createFormTemplate(formTemplate).then(function (template) {
            commit(types.FORM_TEMPLATE_CREATED, { formTemplate: template });
            return template;
        });
    },
    updateFormTemplate: function (_a, formTemplate) {
        var commit = _a.commit;
        return v2Repository.update(formTemplate.id, formTemplate).then(function () { return commit(types.FORM_TEMPLATE_UPDATED, { formTemplate: formTemplate }); });
    },
};
